import anime from 'anime';
import vars from 'variables';
import { $, $$ } from 'query-selector';

export default () => {
  const logo = $('.js-header-logo');
  if (!logo) return;

  const points = [
    ['74.2,55.8 80.5,75.8 100,55.7', '73.1,52.2 90,71.7 100,37.6'],
    ['38.2,0 25,77.6 100,55.7', '50,6.5 32.9,85.1 100,37.6']
  ];

  const polygons = $$('polygon', logo);

  polygons.forEach((p, i) => {
    const anim = {
      targets: p,
      points: [
        ...points[i].map(points => ({ value: points })),
        { value: p.getAttribute('points') }
      ],
      duration: 20000,
      easing: 'cubicBezier(0.25, 0, 0.75, 1)',
      loop: true
    };

    anime(anim);
  });
};
